import { useEffect } from 'react';

import type { TNode } from '@revelio/ui';
import { type TreeData, useTreeApi } from '@revelio/ui';

export interface UseSplitTreeProps {
  companyResults: TreeData[];
  industryResults: TreeData[];
  value: string[];
  search: string;
  onCompanyChange: (ids: string[], nodes?: TNode[]) => void;
  onIndustryChange: (ids: string[], nodes?: TNode[]) => void;
}

export const useSplitTree = ({
  companyResults,
  industryResults,
  value,
  search,
  onCompanyChange,
  onIndustryChange,
}: UseSplitTreeProps) => {
  const companyTreeApi = useTreeApi({
    data: companyResults,
    openByDefault: false,
    initialSelections: value,
    value,
    onChange: onCompanyChange,
  });

  const industryTreeApi = useTreeApi({
    data: industryResults,
    openByDefault: false,
    initialSelections: value,
    value,
    onChange: onIndustryChange,
  });

  useEffect(() => {
    industryTreeApi.onSearch(search);
  }, [search, industryTreeApi]);

  const companyCount = value.filter((id) => id.split('_').length === 3).length;
  const industryCount = value.filter(
    (id) => id.split('_').length === 2 || id.split('_').length === 1
  ).length;

  return {
    companyTreeApi,
    industryTreeApi,
    companyCount,
    industryCount,
  };
};
